import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionHeading, Reveal } from "@/components/Reveal";

const DirectionCard = ({ d, testid, flip }) => {
  const [hovered, setHovered] = useState(null);
  return (
    <Reveal className="h-full">
      <article
        data-testid={testid}
        className="group relative h-full bg-obsidian-surface border hairline rounded-sm p-8 lg:p-12 overflow-hidden transition-[border-color] duration-500 hover:border-gold/40"
      >
        <span className="pointer-events-none absolute -top-8 right-2 font-serif text-[9rem] lg:text-[12rem] leading-none text-transparent select-none" style={{ WebkitTextStroke: "1px rgba(212,175,55,0.14)" }}>
          {d.num}
        </span>
        <p className="text-xs font-mono uppercase tracking-[0.28em] text-gold">{d.num} — {d.label}</p>
        <h3 className="mt-6 font-serif text-xl sm:text-2xl lg:text-[1.65rem] font-medium text-slate-100 leading-snug max-w-md">{d.title}</h3>
        <ul className="mt-10 space-y-0">
          {d.services.map((s, i) => (
            <li key={s}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className="flex items-center justify-between py-3 border-b border-slate-800/70 last:border-0 cursor-default"
              data-testid={`${testid}-service-${i}`}
            >
              <span className={`text-sm sm:text-[15px] font-light transition-colors duration-300 ${hovered === i ? "text-gold" : "text-slate-300"}`}>{s}</span>
              <ArrowUpRight size={14} className={`transition-all duration-300 ${hovered === i ? "text-gold opacity-100 translate-x-0" : "text-slate-600 opacity-0 -translate-x-1"}`} />
            </li>
          ))}
        </ul>
        <motion.div
          className={`absolute bottom-0 h-[2px] bg-gold ${flip ? "right-0" : "left-0"}`}
          initial={{ width: 0 }}
          whileInView={{ width: "38%" }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
        />
      </article>
    </Reveal>
  );
};

export default function Directions() {
  const { t } = useLang();
  return (
    <section id="directions" className="py-24 lg:py-32 bg-obsidian" data-testid="directions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading overline={t.directions.overline} title={t.directions.d1.label + "  ·  " + t.directions.d2.label} testid="directions-title" />
        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <DirectionCard d={t.directions.d1} testid="direction-africa-world" />
          <div className="lg:mt-20">
            <DirectionCard d={t.directions.d2} testid="direction-world-africa" flip />
          </div>
        </div>
      </div>
    </section>
  );
}
